import { generateOrderLines } from "../gtmHelper";
import { pushGTMInternal } from "../pushGtmEvents";

export const gtmTrackAddDipFromBasket = (self, {productSelections}) => {
	try {
		const productCatalog = self.$store.getters.productCatalog;
		const orderLine = (generateOrderLines(self, {productCatalog, productSelections}) || [])[0];
		if(!orderLine) return;
		const dipsOL = orderLine.subLines.find(ol2 => ol2.options.groupType === "dips");
		if (dipsOL && dipsOL.totalPriceAccum) {
			pushGTMInternal(
				"AddDipBasket",
				self.product.name,
				self.$route.path,
				"",
				{
					email: (self.$store.getters.personData || {}).email,
					selectedRestaurant: (self.globalSelectedShop || {}).shopName,
					upsellValue: dipsOL.totalPriceAccum
				}
			);
		}
	} catch(e) {
		// even if something fails in this block, we should proceed
	}
};